import React from "react";

export default class WithResolvedPromises extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting: true,
            promisesResults: [],
            caughtError: null
        };
    }

    componentDidMount() {
        this.resolvePromises(this.props.promises);
    }

    addActions(actions = []) {
        this.setState({ waiting: true });
        this.resolvePromises(actions);
    }

    resolvePromises(promises) {
        Promise.all(promises)
            .then(results => {
                this.setState({ waiting: false, promisesResults: results });
            })
            .catch(caughtError => {
                if (!caughtError) {
                    throw new Error("No reason passed to [catch] handler.");
                }

                let error = {
                    message: caughtError.message,
                    code: caughtError.code
                };

                console.error(caughtError);

                this.setState({ waiting: false, error });
            });
    }

    renderChildren() {
        let { children } = this.props;
        let { promisesResults, caughtError } = this.state;
        return typeof children === "function"
            ? children(this.addActions.bind(this), promisesResults, caughtError)
            : children;
    }

    renderFallbackErrorComponent() {
        return <p>An error occurred: {this.state.error.message}</p>;
    }

    render() {
        let { preloaderComponent, errorComponent } = this.props;
        let { waiting, error } = this.state;
        if (waiting) {
            const PreloaderComponent = preloaderComponent;
            return <PreloaderComponent />;
        } else if (error) {
            const ErrorComponent = errorComponent;

            return errorComponent ? (
                <ErrorComponent error={error} />
            ) : (
                this.renderFallbackErrorComponent()
            );
        }
        return this.renderChildren();
    }
}



// WEBPACK FOOTER //
// ./web/src/components/common/WithResolvedPromises.jsx